import { Avatar, Stack, Typography } from "@mui/material"
import { styles } from "./styles/MessageComment.styles"
import { useAuthContext } from "contexts/AuthContext"
import moment from "moment"
import { ImageZoom } from "components/UI"

export default function MessageComment({
  userId,
  avatar,
  name,
  lastName,
  date,
  comment,
  imageFile: fileURL,
  audioFile: audioRecordURL,
}) {
  const { userData } = useAuthContext()
  return (
    <Stack
      direction={"row"}
      sx={[
        styles.messageComment,
        userData?.userId === userId && styles.messageCommentStudent,
      ]}
    >
      <Stack
        sx={[
          styles.messageProfileAvatar,
          userData?.userId === userId && styles.messageProfileAvatarStudent,
        ]}
      >
        <Avatar src={avatar} />
      </Stack>
      <Stack
        sx={[
          styles.commentData,
          userData?.userId === userId
            ? styles.commentDataStudent
            : styles.commentDataTeacher,
        ]}
      >
        <Stack direction={"row"} alignItems={"center"} spacing={0.5}>
          <Typography variant="span" sx={styles.commentUser}>
            {name} {lastName}
          </Typography>
          <Typography variant="span" sx={styles.commentDate}>
            {moment(date).format("DD/MMM/YYYY HH:mm:ss")}
          </Typography>
        </Stack>
        <Typography sx={styles.comment}>{comment}</Typography>
        {fileURL && <ImageZoom src={fileURL} zoomEnabled={false} />}
        {audioRecordURL && (
          <audio
            controls
            src={audioRecordURL}
            style={{ width: "100%", height: 35 }}
          />
        )}
      </Stack>
    </Stack>
  )
}
